export const getComponentByType = (type) => {
    switch (type) {
        case 'singleText':
            return {
                type, label: 'Single text line question', description: '', validation: {min: 1, max: 50},
            };
        case 'textBox':
            return {
                type, label: 'Textbox question', description: '',
            };
        case 'checkboxQuestion':
            return {
                type, label: 'Checkbox Question', description: '',
            };
        case 'signature':
            return {
                type, label: 'Signature'
            };
        case 'additionalNotes':
            return {
                type, label: 'Notes', description: '',
            };
            case 'attachment':
            return {
                type, label: 'Attachment', description: '', attachments: [],
            };
        case 'multipleChoice':
            return {
                type,
                label: 'Multiple Choice Question',
                description: '',
                options: [{index: 0, description: ''}, {index: 1, description: ''}, {index: 2, description: ''}],
            };
        case 'singleChoice':
            return {
                type,
                label: 'Single Choice Question',
                description: '',
                options: [{index: 0, description: ''}, {index: 1, description: ''}, {index: 2, description: ''}],
            };
        default:
            break;
    }
}